/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import AppCard from "./AppCard";
import { LoadingStatus } from "../../rootReducer/actions";
import LoaderPage from "./LoaderPage";
import NoResultsFound from "./NoResultsFound";
import { App } from "../../api/apiCalls";
import { MAIN_TITLES } from "../../config.json";

interface PageData {
  loadingStatus: LoadingStatus;
  apps: App[];
  pageNo: number;
  totalPages: number;
  totalElements: number;
}

interface AppGutterProps {
  pageData: PageData;
  mainHeading?: string;
  subHeading?: string;
  note?: string;
  keyword?: string;
  parameters?: {
    category?: string;
    categoryId?: string;
    keyword?: string;
  };
}

export default function AppGutter({
  pageData,
  mainHeading,
  subHeading,
  note,
  keyword,
  parameters,
}: AppGutterProps) {
  return (
    <div className="row mt-sm-5 mt-0">
      {pageData.apps?.length !== 0 && pageData.apps[0] !== null && (
        <div className="col-lg-2 pr-0">
          <h4 className="font-weight-bold m-0">
            {mainHeading || (keyword && MAIN_TITLES.SEARCH_RESULTS)}
          </h4>
          <h4 className="font-weight-bold text-secondary">
            {subHeading || (keyword && keyword)}
          </h4>
          <p className="sub-text">{note}</p>
        </div>
      )}

      {pageData?.loadingStatus === LoadingStatus.LOADING_SUCCESS ? (
        pageData.apps?.length !== 0 && pageData.apps[0] !== null ? (
          <div className="col-lg-10">
            <div className="row no-gutters apps-row">
              {pageData.apps.map((app) => {
                return <AppCard key={app.appId} app={app} />;
              })}
            </div>
          </div>
        ) : (
          <NoResultsFound keyword={parameters?.keyword} />
        )
      ) : (
        <LoaderPage />
      )}
    </div>
  );
}
